/**
 * Images live on a plain CDN with no transforms, so full-size files would be
 * downloaded for slots a few hundred pixels wide. These helpers route them
 * through a resizing image proxy that returns compressed WebP at the needed width.
 */
const PROXY = 'https://wsrv.nl/'

export const IMAGE_PROXY_ORIGIN = 'https://wsrv.nl'

export function optimizedImage(src: string, width: number, quality = 66): string {
  return `${PROXY}?url=${encodeURIComponent(src)}&w=${width}&output=webp&q=${quality}&af`
}

export function optimizedSrcSet(src: string, widths: number[], quality = 66): string {
  return widths.map((width) => `${optimizedImage(src, width, quality)} ${width}w`).join(', ')
}

/**
 * The hero mockup is the LCP element, so its candidates stay deliberately small:
 * the largest phone request is ~540px wide instead of a 2x 768px file.
 */
export const HERO_WIDTHS = [320, 420, 540, 700]
export const HERO_SIZES = '(max-width: 640px) 88vw, 520px'

/** The offer section shows the same mockup — reusing the hero widths keeps it cached. */
export const OFFER_WIDTHS = HERO_WIDTHS
export const OFFER_SIZES = '(max-width: 640px) 84vw, 380px'

export const BONUS_WIDTHS = [280, 380, 520]
export const BONUS_SIZES = '(max-width: 640px) 84vw, 300px'
